import { useParams } from "react-router-dom";
import { useCampaignOwnerList } from "../reuseableEffects";

const UserCampaignsList = () => {

    const { email } = useParams();
    const decodeEmail = atob(email);
    console.log(email, decodeEmail)

    const campaignOwnerList = useCampaignOwnerList(decodeEmail);
    console.log(campaignOwnerList)

    return ( 
        <div>UserCampaignsList</div>
     );
}
 
export default UserCampaignsList;